
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".344","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M5.885 14.033c-.234 0-.402-.084-.504-.252-.094-.178-.066-.36.084-.546l3.22-4.34L5.66 4.793c-.159-.206-.192-.392-.098-.56a.512.512 0 01.476-.266c.233 0 .443.126.63.378l2.688 3.682 2.674-3.682c.177-.252.382-.378.616-.378.224 0 .382.088.476.266.102.168.074.354-.084.56L10 8.895l3.234 4.34c.14.187.163.369.07.546-.094.168-.257.252-.49.252-.234 0-.444-.126-.63-.378L9.343 9.763 6.5 13.655c-.178.252-.383.378-.616.378z","fill":"#000"}})])
          )
        }
      }
    